export default __webpack_public_path__ + "static/media/IconDesc_OilRefinery.256.fef647a1.png";